import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues, FieldArray } from 'redux-form';
import { ButtonGroup } from '../../ReduxForm';
import { get } from 'lodash';
import Markdown from 'react-markdown';
import PsychiatricQuestionBox from '../../../PsychiatricQuestionBox';
import {
  Button,
  ButtonBar,
  SimpleFormControl,
} from '../../../../../../common/components';
import parseInteger from '../../../../../../helpers/parseInteger';
import TravellersMedicalArray from '../TravellersMedicalArray/TravellersMedicalArray';
import { Alert, Col, ControlLabel, Row } from 'react-bootstrap';
import './styles/MedicalTab.scss';

const MEDICAL_META = 'data.attributes.metadata.medical_declaration_questions';
const PSY_QUESTION_META =
  'data.attributes.metadata.medical_declaration_question_overrides';
const MEDICAL = {
  headingOne:
    'You must declare ALL pre-existing medical conditions for yourself and any travellers named on the policy.',
  headingTwo:
    'Travellers named on the policy must not be travelling against the advice of a doctor or medical professional, ' +
    'travelling specifically to receive medical treatment during the trip, or in the knowledge that they are likely ' +
    'to need medical treatment.',
  headingThree:
    'Pre-existing medical conditions will only be covered if declared and accepted by us in writing. ' +
    'Failure to declare ALL pre-existing medical conditions may result in claims being rejected.',
};

const MedicalDeclarationTab03 = ({
  dispatch,
  change,
  formValues,
  definitions,
  screeningIndex,
  isRescreenRequired,
  onGoToPreviousPage,
  onGoToQuotes,
  onEnableQuoteTab,
  onClearError,
}) => {
  const hasMedicalOverrides =
    formValues?.data?.attributes?.metadata?.has_medical_overrides;
  const numAdults = formValues?.data?.attributes?.metadata?.adults?.length;
  useEffect(
    () => {
      if (hasMedicalOverrides === true) {
        dispatch(change(PSY_QUESTION_META, ['has-psychiatric-condition']));
      } else {
        dispatch(change(PSY_QUESTION_META, ''));
      }
    },
    [hasMedicalOverrides, dispatch, change],
  );

  // componentDidMount() {
  //   const { dispatch, change, currentProduct, formValues } = this.props;
  //
  //   const medDecQuestions = get(
  //     formValues,
  //     'data.attributes.metadata.medical_declaration_questions',
  //     [],
  //   );
  //   if (!medDecQuestions || medDecQuestions.length === 0) {
  //     const productMedicalQuestions =
  //       currentProduct.data.attributes.metadata.medical_declaration_questions;
  //     dispatch(
  //       change(
  //         'data.attributes.metadata.medical_declaration_questions',
  //         productMedicalQuestions,
  //       ),
  //     );
  //   }
  //   dispatch(change('data.current_tab', 3));
  //   dispatch(this.props.change('data.first_render', false));
  //   this.props.enableQuoteTab();
  // }

  useEffect(() => {
    // if (!formMedicalDeclarationQuestions || formMedicalDeclarationQuestions.length === 0){
    //   dispatch(
    //         change(
    //           'data.attributes.metadata.medical_declaration_questions',
    //           productMedicalQuestions,
    //         ),
    //       );
    // }
    onEnableQuoteTab();
  }, []);

  // const updateConditionsCovered = (value) => {
  //
  //   this.props.dispatch(
  //     this.props.change(
  //       'data.attributes.metadata.adults[' +
  //       index +
  //       '].conditions_covered',
  //       value,
  //     ),
  //   );
  // }

  // const updateScreening = (screening, screeningId) => {
  //   updateTravellerScreening(screening, screeningId, `data.attributes.metadata.adults.${index}`)
  // }
  const questions =
    formValues?.data.attributes.metadata?.medical_declaration_questions ?? [];
  const showTerminalQuestion = questions?.['is-terminal']?.answer ?? false;
  const questionList = Object.values(questions);
  const isScreeningRequired = !!questionList.find(
    (question) => question.question_type === 'boolean' && question.answer,
  );

  const answers =
    formValues?.data.attributes.metadata?.medical_declaration_questions ?? {};
  return (
    <div>
      {isRescreenRequired && (
        <Alert bsStyle={'danger'}>IMPORTANT: Re-screen is required</Alert>
      )}
      <div className="form-horizontal">
        <h4>
          <strong>Medical Declaration</strong>
        </h4>
        <div className="divider" />
        <div className="default-text-medical">
          {MEDICAL.headingOne}
          <br />
          <br />
          {MEDICAL.headingTwo}
          <br />
          <br />
          {MEDICAL.headingThree}
          <br />
          <br />
        </div>
      </div>
      <div className="questions">
        {Object.keys(answers).map((questionKey) => {
          const declaration = answers[questionKey];
          if (declaration.type && declaration.type === 'header') {
            return (
              <div key={questionKey}>
                <div>
                  <Markdown source={declaration.content || ''} />
                </div>
              </div>
            );
          }
          if (questionKey === 'terminal-question' && !showTerminalQuestion) {
            return;
          }
          return (
            <div className="medical-question" key={questionKey}>
              <div className="medical-internal-container">
                <div className="medical-question-text" style={{ padding: '15px 15px' }}>
                  {declaration.question_type === 'boolean' && (
                    <div>
                      <Markdown source={declaration.content || ''} />
                    </div>
                  )}
                  {questionKey === 'terminal-question' && showTerminalQuestion && (
                    <div className="terminal-question">
                      <Markdown source={declaration.content || ''} />
                    </div>
                  )}
                </div>
                <div className="medical-buttons-container" style={{ paddingTop: '15px' }}>
                  {declaration.question_type === 'boolean' && (
                    <div>
                      <Field
                        inline
                        component={ButtonGroup}
                        noFormGroup
                        name={
                          'data.attributes.metadata.medical_declaration_questions[' +
                          questionKey +
                          '].answer'
                        }
                        options={[
                          { label: 'Yes', value: true },
                          { label: 'No', value: false },
                        ]}
                      />
                    </div>
                  )}
                  {questionKey === 'terminal-question' && showTerminalQuestion && (
                    <div>
                      <Field
                        inline
                        type={'number'}
                        parse={parseInteger}
                        component={SimpleFormControl}
                        name={
                          'data.attributes.metadata.medical_declaration_questions[' +
                          questionKey +
                          '].answer'
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
              {!!get(formValues, `${MEDICAL_META}[${questionKey}].answer`, false) &&
                questionKey === 'has-psychiatric-condition' && (
                  <Field
                    name="data.attributes.metadata.medical_declaration_question_overrides"
                    definitions={definitions}
                    component={PsychiatricQuestionBox}
                  />
                )}
            </div>
          );
        })}
      </div>
      <hr />
      {isScreeningRequired && (
        <Row className="medical-screening">
          <Col xs={12} className="screening-message">
            <ControlLabel>
              As you answered "yes" to one or more of the medical declaration questions
              above you are required to go through the medical screening process for each
              traveller in order to proceed with your quote.
            </ControlLabel>
          </Col>
          <Col xs={12}>
            <FieldArray
              name={'data.attributes.metadata.adults'}
              travellerStartIndex={0}
              component={TravellersMedicalArray}
              region={formValues?.data?.attributes?.metadata?.region ?? ''}
              tripType={formValues?.data?.attributes?.metadata?.scheme_type ?? ''}
              destinations={formValues?.data?.attributes?.metadata?.destinations ?? []}
              onClearError={onClearError}
            />

            <FieldArray
              name={'data.attributes.metadata.children'}
              travellerStartIndex={numAdults}
              component={TravellersMedicalArray}
              region={formValues?.data?.attributes?.metadata?.region ?? ''}
              tripType={formValues?.data?.attributes?.metadata?.scheme_type ?? ''}
              destinations={formValues?.data?.attributes?.metadata?.destinations ?? []}
              onClearError={onClearError}
            />
          </Col>
        </Row>
      )}
      <Row>
        <div className="actions">
          <ButtonBar includeDivider={true}>
            <Button
              label="Back"
              bsStyle="secondary"
              disabled={screeningIndex !== 0}
              className="btn-action-back pull-left button-action-back"
              handleClick={onGoToPreviousPage}
            />
            <Button
              label="Next"
              id={'leisure-travel-medical-btn-next'}
              bsStyle="primary"
              className="pull-right btn-action button-action-next"
              disabled={screeningIndex !== 0}
              handleClick={onGoToQuotes}
            />
          </ButtonBar>
        </div>
      </Row>
    </div>
  );
};

const FORM_NAME = 'LeisureTravelForm';
const form = reduxForm({ form: FORM_NAME })(MedicalDeclarationTab03);
const mapStateToProps = (state, props) => {
  return {
    auth: state.auth,
    initialValues: props.resource,
    form: FORM_NAME,
    formValues: getFormValues(FORM_NAME)(state),
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
    product: state.product,
  };
};

export default connect(mapStateToProps)(form);
